import { render } from "./ModalFocusPointContent.vue?vue&type=template&id=4bfb3db6&scoped=true"
import script from "./ModalFocusPointContent.vue?vue&type=script&lang=js"
export * from "./ModalFocusPointContent.vue?vue&type=script&lang=js"

import "./ModalFocusPointContent.vue?vue&type=style&index=0&id=4bfb3db6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bfb3db6"]])

export default __exports__